<div *ngIf="this.applicantId" id="onfido-mount"></div>
<h1 *ngIf="!this.applicantId" translate>videoselfing.error.process</h1>
